<script>


export default {
    props: {
    },
    data() {
        return {
            
        }
    },
    computed: {

    },
    methods: {

    }
}
</script>
<template>
  <button class="btn btn-xs">
    <icon-trash width="12" height="16" />
  </button>
</template>